import {
  CommonRequest,
  CommonResponse,
  DmlResponse,
  Method,
  ServiceName,
} from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import { SetupOrgEqcl, SetupOrgEqclCondition } from 'models/setup/SetupOrgEqcl';

export const findOrgEqcl = async (condition?: SetupOrgEqclCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/org-eqcl`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };
  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : []) as SetupOrgEqcl[];
};

/** 일괄 저장 (crudKey C/U/D) — 세션 사용자 기준으로 서버가 실행한다 */
export const saveOrgEqcl = async (items: SetupOrgEqcl[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/org-eqcl`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: items,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);
  return response;
};
